import { GroupParticipantsStore } from '@stores/group-participants.store';
import ApiResponse from '@stores/ApiResponse';
import { CohortUser } from '@models/CohortUser';
import { Role, RoleValues } from '@app/enums/Role';
import { Duration } from 'luxon';
import { useQuery } from '@tanstack/react-query';
import { ParticipantView } from '@views';

export class ActiveParticipantsViewCreator {
  constructor(private readonly store = new GroupParticipantsStore()) {}

  async createView(groupId: number): Promise<ParticipantView[]> {
    const response = await ApiResponse.handleApiResponse<CohortUser[]>(() => this.store.readByGroupId(groupId));
    const activeParticipants = response
      .filter((u) => u.isActive && RoleValues[u.role] === Role.Participant)
      .map((u) => {
        return {
          id: u.id,
          name: u.user.name,
          email: u.user.email,
          role: u.role,
          avatarUrl: u.user.avatarUrl,
          CohortUser: u,
          isNew: false,
        } as ParticipantView;
      });
    return activeParticipants;
  }
}

export const useActiveParticipantsViewCreator = (groupId: number) =>
  useQuery({
    queryKey: [ActiveParticipantsViewCreator.name, groupId],
    queryFn: () => new ActiveParticipantsViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
  });
